<div class="py-4 px-0">
  <div class="container">
    <h1>{{ "collections.search.title" | translate }}</h1>

    <div class="row">
      <div class="col">
        @if (loading) {
          <div class="d-flex align-items-center">
            <div class="spinner-border me-2" role="status" aria-hidden="true"></div>
            <strong>{{ "search.results.loading" | translate }}</strong>
          </div>
        } @else {
          @if (results?.hits > 0) {
            <div id="results">
              <div class="block-header">
                <span class="results-count">{{ results.hits }} {{ "search.results.results" | translate }}</span>
              </div>
              @for (result of results.results; track result) {
                <app-collection-search-result
                [result]="result"></app-collection-search-result>
              }
            </div>
          } @else {
            <p>{{ "search.results.noResults" | translate }}</p>
          }
        }

      </div>
    </div>
  </div>
</div>
